import logo from '../../images/logos/kegstar-logo.svg'
import logoWhite from '../../images/logos/kegstar-logo-white.svg'
import ThemeToggle from '../../components/ThemeToggle/ThemeToggle'
import {useTheme} from '../../contexts/ThemeContext'

export default function NavBar() {
  const {effectiveTheme} = useTheme()
  const logoImage = effectiveTheme === 'light' ? logo : logoWhite
  return (
    <div className="border-b border-sky-400/70 dark:border-slate-700 shadow-md bg-sky-500 dark:bg-slate-900 bg-clip-content bg-origin-content transition-colors">
      <div
        className={[
          'max-w-md my-0 mx-auto overflow-x-hidden',
          'flex items-center justify-between p-4',
        ].join(' ')}
      >
        <img
          src={logoImage}
          alt="logo"
          className="w-24 h-auto"
        />
        <ThemeToggle />
      </div>
    </div>
  )
}
